import { Component, Mixins } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import LanguageModel from '@/views/Language/models/language'
import TranslationJobModel from '@/views/Language/models/translationJob'
import TagModel from '@/views/Language/models/tag'

@Component({})
export default class LanguageIndex extends Mixins<MixinInterface>() {
    get token() {
        return this.$route.params.token
    }

    get hasAccess() {
        return this.token || this.isSuperuser
    }

    loading = true
    authorized = true

    async mounted() {
        this.loading = true
        let languages = await LanguageModel.getAllTranslationLanguages()
        this.$store.commit('translationLanguages', languages)
        let tags = await TagModel.getAllTags(this.token)
        this.$store.commit('tags', tags)

        if (this.token) {
            let translationJobs = await TranslationJobModel.getAllTranslationJobs(this.token).catch(
                () => {
                    //
                }
            )

            if (translationJobs) {
                this.$store.commit('translationJob', translationJobs[0] ? translationJobs[0] : null)
            } else {
                this.authorized = false
            }
        } else {
            this.$store.commit('translationJob', null)
        }

        this.loading = false
    }
}
